"use client";

import { PageLayout } from "@/components/ui/PageLayout";
import SwapComponent from "@/components/Swap";

export default function SwapPage() {
  return (
    <PageLayout>
      <div className="space-y-6 anim-fadeSlideInUp-500ms">
        <div className="text-center mb-7 anim-fadeSlideInUp-300ms" style={{ animationDelay: "0.2s" }}>
          <h1 className="text-[28px] font-normal font-serif leading-tight mb-1">Swap</h1>
          <p className="text-[11px] tracking-[0.04em]" style={{ color: "var(--text-secondary)" }}>
            Swap tokens across Stellar protocols at the best rates
          </p>
        </div>
        <SwapComponent />
      </div>
    </PageLayout>
  );
}
